const map = {
	"./10ALabs.png": 7911,
	"./align.png": 9068,
	"./americanBTC.png": 7200,
	"./atlasInvest.png": 937,
	"./copia.png": 5239,
	"./dimensional.png": 9344,
	"./electronx.png": 3125,
	"./engageli.png": 2691,
	"./futureSecureAi.png": 5575,
	"./hedral.png": 9439,
	"./insitro.png": 9381,
	"./ionic.png": 2269,
	"./kai.png": 7834,
	"./khosla.png": 7585,
	"./nirvana.png": 1028,
	"./novaCredit.png": 8938,
	"./nurl.png": 2546,
	"./pioneerLabs.png": 1673,
	"./prosights.png": 8240,
	"./renegade.jpg": 4442,
	"./reserv.png": 8660,
	"./rhino.png": 5665,
	"./salt.png": 6459,
	"./solari.png": 6771,
	"./spacial.png": 8510,
	"./spade.png": 8120,
	"./tabflows.png": 2803,
	"./treasureTrove.png": 5596,
	"./truvo.png": 2349,
	"./tulu.png": 4819,
	"./turnout.png": 2264,
	"./vegaClaims.png": 7775
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5921;